import React from 'react';
import classNames from 'classnames';

export interface IFilterItem {
  id: string;
  name: string;
  active: boolean;
}

interface IFilterItemProps {
  filter: IFilterItem;
  onFilter: (id: string, futureState: boolean) => void;
}

const FilterItem: React.FC<IFilterItemProps> = props => {
  const { filter, onFilter } = props;

  return filter ? (
    <button
      onClick={() => onFilter(filter.id, !filter.active)}
      className={classNames('filter_item', { active: filter.active })}>
      {filter?.name || ''}
    </button>
  ) : null;
};

export default FilterItem;
